/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeFirIcon16Solid = forwardRef('NaturePlantTreeFirIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.763 1.128a1 1 0 0 0-1.526 0L2.292 6.971A.625.625 0 0 0 2.77 8h1.968l-3.437 3.966A.625.625 0 0 0 1.774 13H7v2a1 1 0 0 0 2 0v-2h5.226c.536 0 .823-.63.472-1.034L11.261 8h1.97c.532 0 .82-.623.477-1.029L8.763 1.128Z" })));
});
